<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']" titleText="i18n.domain.reports.saved-reports.title"></app-title-bar>
<div class="d-lg-flex align-items-center mb-2" *ngIf="allowClientSelection" >
  <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
</div>
<ng-container>
  <ejs-grid #grid
            class="grid-with-toolbar"
            width="100%"
            rowHeight="38"
            [dataSource]="data"
            [allowSorting]="true"
            [allowFiltering]="true"
            [editSettings]="editSettings"
            [filterSettings]="filterSettings"
            (actionComplete)="actionComplete($event)"
            (actionBegin)="actionBegin($event)">
    <ng-template #toolbarTemplate
                 let-data>
      <ejs-toolbar>
        <div>
          <div class="e-toolbar-item">
            <button ejs-dropdownbutton
                    class="full-line-height e-tbar-btn e-tbtn-txt e-control e-btn e-lib toolbar-dropdownbutton"
                    iconCss="e-btn-icon e-icons icon-add e-icon-left"
                    [content]="'i18n.domain.reports.add-title' | translate"
                    [items]="enumSelectionData"
                    (select)="navigateToReport($event)"
                    (beforeItemRender)='onBeforeItemRender($event)'>
            </button>
          </div>
        </div>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field="id"
                [visible]="false"
                [isPrimaryKey]="true"></e-column>
      <e-column field="reportName"
                [allowFiltering]="true"
                [allowSorting]="true"
                headerText="{{'i18n.domain.reports.grid.reportName' | translate}}"
                clipMode="EllipsisWithTooltip"></e-column>
      <e-column field="createdDateTime"
                type="date"
                format="dd.MM.yyyy"
                [filter]="dateFilter"
                [allowFiltering]="true"
                [allowSorting]="true"
                headerText="{{'i18n.domain.reports.grid.date' | translate}}"
                clipMode="EllipsisWithTooltip"></e-column>
      <e-column field="createdByName"
                [allowFiltering]="true"
                [allowSorting]="true"
                type="string"
                headerText="{{'i18n.domain.reports.grid.createdBy' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="reportType"
                [allowFiltering]="true"
                [allowSorting]="true"
                [filter]="typeFilter"
                headerText="{{'i18n.domain.reports.grid.type' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #filterItemTemplate
                     let-data>
          {{getReportTypeString(data) | translate}}
        </ng-template>
        <ng-template #template
                     let-data>
          <span>{{getReportTypeString(data) | translate}}</span>
        </ng-template>
      </e-column>
      <e-column headerText=""
                clipMode="EllipsisWithTooltip">
        <ng-template #template
                     let-data>
          <div class="d-flex align-items-end">
            <div class="flex-grow-1"></div>
            <span class="icon-download cursor-pointer"
                  (click)="downloadFile(data.id)"></span>
          </div>
        </ng-template>
      </e-column>
    </e-columns>
    <ng-template #editSettingsTemplate
                 let-data>
      <app-reports-form [reportsEditForm]="gridEditForm"></app-reports-form>
    </ng-template>
  </ejs-grid>
</ng-container>
